import React from 'react';
import Navbar from "../Navbar";
import Footer from "../Footer";
import './AboutUs.css';

const AboutUs = () => {
  return (
    <div className="home-container">
      <Navbar />

      {/* ── Hero ─ */}
      <section className="about-hero">
        <div className="about-hero-content">
          <h1>About <span style={{
              background: "linear-gradient(135deg, #ff8c00, #ff5500)",
              WebkitBackgroundClip: "text",
              backgroundClip: "text",
              color: "transparent"
            }}> Roam The World</span></h1>
          <p>Roam The World – Making Every Journey Memorable.</p>
        </div>
      </section>

      {/* ── Stats Bar ─ */}
      <div className="about-stats-bar">
        <div className="about-stat-item">
          <span className="stat-number">500+</span>
          <span className="stat-label">Happy Travelers</span>
        </div>
        <div className="about-stat-item">
          <span className="stat-number">50+</span>
          <span className="stat-label">Destinations Covered</span>
        </div>
        <div className="about-stat-item">
          <span className="stat-number">5+</span>
          <span className="stat-label">Years of Experience</span>
        </div>
        <div className="about-stat-item">
          <span className="stat-number">100%</span>
          <span className="stat-label">Personalised Trips</span>
        </div>
      </div>

      {/* ── Our Story / Introduction ── */}
      <section className="about-mission-section">
        <div className="about-mission-inner">
          <div className="about-mission-text">
            <p className="about-eyebrow">🌍 Who We Are</p>
            <h2 className="about-section-title">Transforming Travel Experiences Since 2021</h2>
            <p>
              Established in <strong>December 2021</strong>, Roam The World was founded with a vision to transform the way people experience travel. Since our inception, we have been committed to delivering exceptional travel solutions, personalized service, and unforgettable journeys for travelers across the globe.
            </p>
            <p>
              At Roam The World, we understand that every traveler is unique. Whether it's a dream vacation, luxury holiday, honeymoon, corporate travel, MICE event, cruise, or an international adventure, our team meticulously plans every detail to ensure a seamless and enriching travel experience.
            </p>
            <p>
              We take pride in offering comprehensive travel services including <strong>flight bookings, hotel reservations, visa assistance, travel insurance, customized holiday packages, destination weddings, and corporate travel management</strong>. Our dedication to quality, transparency, and customer satisfaction has helped us build lasting relationships with clients who trust us to bring their travel dreams to life.
            </p>
          </div>
          <div className="about-mission-image">
            <img
              src="https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=800"
              alt="Travel experiences"
              loading="lazy"
            />
          </div>
        </div>
      </section>

      {/* ── Founder's Message (New Section) ── */}
      <section className="founder-section">
        <div className="founder-container">
          <div className="founder-image-wrapper">
            {/* Placeholder image for Founder - Replace with actual photo if available */}
            <img 
              src="https://images.unsplash.com/photo-1560250097-0b93528c311a?w=600" 
              alt="Abhishek Kuntalwar" 
              loading="lazy" 
            />
            <div className="founder-badge">Founder & CEO</div>
          </div>
          <div className="founder-content">
            <p className="about-eyebrow">A Message from Our Founder</p>
            <h2 className="about-section-title" style={{textAlign: 'left'}}>Abhishek Kuntalwar</h2>
            <div className="founder-quote-box">
              <span className="quote-icon">“</span>
              <p>
                Travel has the extraordinary ability to connect people, cultures, and dreams. When I founded Roam The World in December 2021, my vision was not simply to build a travel company, but to create a trusted brand that helps people explore the world with confidence, comfort, and excitement.
              </p>
              <p>
                Every journey represents a story waiting to be written. Whether it is a family holiday, a honeymoon, a business trip, or a once-in-a-lifetime adventure, our mission is to make every moment memorable and every experience exceptional. At Roam The World, we treat every client's journey as our own and strive to deliver service that goes beyond expectations.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ── Why Choose Us ── */}
      <section className="about-why-section">
        <h2>Why Travelers Choose Us</h2>
        <span className="about-why-subtitle">We don't just plan trips — we create memories that last a lifetime.</span>
        <div className="about-why-grid">
          {[
            { icon: '🗺️', title: 'Personalised Itineraries', desc: 'Every trip is designed around you — your interests, budget, and pace. No cookie-cutter packages.' },
            { icon: '🤝', title: 'End-to-End Support', desc: 'From visa paperwork to airport transfers, we handle every detail so your journey is stress-free.' },
            { icon: '💰', title: 'Best Value Deals', desc: 'We negotiate the best rates across hotels, flights, and tours — so you get more for every rupee.' },
            { icon: '📞', title: '24/7 Assistance', desc: 'Our team is available round the clock during your trip. You\'re never alone on the road.' },
            { icon: '🌐', title: 'Global Destinations', desc: 'From Bali to Europe, Maldives to Manali — we cover 50+ destinations worldwide.' },
            { icon: '⭐', title: 'Trusted by 500+ Families', desc: 'Our repeat clients and five-star reviews speak louder than any brochure.' },
          ].map((item, i) => (
            <div className="about-why-card" key={i}>
              <div className="about-why-icon">{item.icon}</div>
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ─ Services ── */}
      <section className="about-services-section">
        <h2>What We Offer</h2>
        <span className="about-services-subtitle">A full suite of travel services — all under one roof in Nagpur.</span>
        <div className="about-services-grid">
          {[
            { icon: '🏢', title: 'MICE', desc: 'Meetings, Incentives, Conferences & Events planned to perfection.' },
            { icon: '📄', title: 'Visa Assistance', desc: 'Hassle-free visa documentation and application support for any country.' },
            { icon: '🏨', title: 'Hotel Booking', desc: 'Handpicked stays from boutique hideaways to luxury resorts worldwide.' },
            { icon: '️', title: 'Flight Booking', desc: 'Best fares on domestic and international flights with flexible options.' },
            { icon: '🚌', title: 'Tour Packages', desc: 'Curated group and private tour packages for every kind of traveller.' },
            { icon: '💑', title: 'Honeymoon Trips', desc: 'Romantic escapes designed to make your first trip together truly magical.' },
          ].map((item, i) => (
            <div className="about-service-card" key={i}>
              <span className="about-service-icon">{item.icon}</span>
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ── Guest Gallery / Testimonials ── */}
      <section className="about-gallery-section">
        <h2>Stories From Our Travelers</h2>
        <span className="about-gallery-subtitle">Real experiences shared by the families and adventurers we've had the privilege of serving.</span>
        <div className="about-gallery-grid">

          {/* Featured card */}
          <div className="about-guest-card about-guest-card--featured">
            <div className="about-guest-img-wrap">
              <img src="https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?w=900" alt="Bali trip" loading="lazy" />
              <span className="about-guest-destination-badge">📍 Bali, Indonesia</span>
              <span className="about-guest-rtw-badge">✈️ Roam the World</span>
            </div>
            <div className="about-guest-info">
              <h4>Sharma Family, Nagpur</h4>
              <div className="about-guest-rating">★★★★★</div>
              <p>"The entire Bali trip was flawlessly arranged — from airport pickup to every resort. We didn't have to worry about a single thing. Roam the World truly exceeded our expectations!"</p>
            </div>
          </div>

          <div className="about-guest-card">
            <div className="about-guest-img-wrap">
              <img src="https://images.unsplash.com/photo-1514890547357-a9ee288728e0?w=600" alt="Maldives" loading="lazy" />
              <span className="about-guest-destination-badge">📍 Maldives</span>
            </div>
            <div className="about-guest-info">
              <h4>Priya & Rahul — Honeymoon</h4>
              <div className="about-guest-rating">★★★★★</div>
              <p>"Our honeymoon package was beyond dreamy. Overwater villa, candlelit dinners — everything was perfect. Thank you RTW!"</p>
            </div>
          </div>

          <div className="about-guest-card">
            <div className="about-guest-img-wrap">
              <img src="https://images.unsplash.com/photo-1431274172761-fca41d930114?w=600" alt="Europe tour" loading="lazy" />
              <span className="about-guest-destination-badge">📍 Europe</span>
            </div>
            <div className="about-guest-info">
              <h4>Deshmukh Family</h4>
              <div className="about-guest-rating">★★★★★</div>
              <p>"7-country Europe tour with kids and elders — they managed visa, hotels, and coaches seamlessly. Highly recommended!"</p>
            </div>
          </div>

          <div className="about-guest-card">
            <div className="about-guest-img-wrap">
              <img src="https://images.unsplash.com/photo-1542397284385-6010376c5337?w=600" alt="Kerala" loading="lazy" />
              <span className="about-guest-destination-badge">📍 Kerala, India</span>
            </div>
            <div className="about-guest-info">
              <h4>Kolte Group Tour</h4>
              <div className="about-guest-rating">★★★★★</div>
              <p>"Group of 22 people, and everything was coordinated perfectly. Houseboat stay was the highlight. Will book again!"</p>
            </div>
          </div>

        </div>
      </section>

      {/* ── Contact Banner ── */}
      <div className="about-contact-banner">
        <div className="about-contact-banner-text">
          <h2>Let's Plan Your Next Adventure</h2>
          <p>Visit us in Nagpur or reach out instantly — our travel experts are ready to craft your perfect trip.</p>
          <div className="about-contact-info-list">
            <div className="about-contact-info-item">
              <i></i>
              <span>+91-9096785868</span>
            </div>
            <div className="about-contact-info-item">
              <i>️</i>
              <span>roamtheworld.ngp@gmail.com</span>
            </div>
            <div className="about-contact-info-item">
              <i>📍</i>
              <span>Shop No 04A, NKY Tower Building First Floor Near Ajni Metro station Nagpur - 440015</span>
            </div>
          </div>
        </div>
        <div className="about-contact-actions">
          <button
            className="about-whatsapp-btn"
            onClick={() => window.open('https://wa.me/919096785868?text=Hi! I found you on your website and want to plan a trip.', '_blank')}
          >
            <img src="/assets/images/whatsapp.png" alt="WhatsApp" style={{ width: 22, height: 22 }} />
            Chat on WhatsApp
          </button>
          <button
            className="about-call-btn"
            onClick={() => window.open('tel:+919096785868')}
          >
            📞 Call Us Now
          </button>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default AboutUs;